// extracted by mini-css-extract-plugin
export default {"content":"SelectTypeStep_content__luSIe","subtitle":"SelectTypeStep_subtitle__it1kI"};